<template>
  <div class="fill-height">
    <v-container class="fill-height">
      <v-row align="center" class="fill-height" justify="center">
        <div class="register elevation-15">
          <h3 class="font-weight-bold text-center py-3 black--text">
            마이 페이지
          </h3>

          <v-form class="pa-3 text-center" ref="form">
            <v-text-field
              readonly
              filled
              class="pl-3 pr-3"
              label="E-mail"
              prepend-icon="mdi-email"
              :value="results.username"
            >
            </v-text-field>

            <v-text-field
              :rules="nameRules"
              class="pl-3 pr-3"
              label="Name"
              prepend-icon="mdi-account"
              @keyup.enter="modifyMyPage"
              required
              type="text"
              v-model="member.nickname"
            >
            </v-text-field>

            <v-text-field
              :rules="passwordRules"
              class="pl-3 pr-3"
              label="NEW Password"
              prepend-icon="mdi-lock"
              required
              type="password"
              v-model="member.password"
            >
            </v-text-field>

            <v-text-field
              :rules="validatePasswordRules"
              class="pl-3 pr-3"
              label="Re-enter NEW password"
              prepend-icon="mdi-lock"
              required
              type="password"
              v-model="validatePassword"
              @keyup.enter="modifyMyPage"
            >
            </v-text-field>

            <v-btn @click="modifyMyPage" class="mt-3" color="indigo" outlined>
              MODIFY
            </v-btn>
          </v-form>
        </div>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { router } from "../router/index";
import { setSnackBarInfo } from "../js/common_function";

export default {
  name: "Resister",

  data() {
    return {
      dialog: false,
      member: {
        nickname: "",
        password: "",
      },
      results: [],
      errors: [],
      validatePassword: "",
      validatePasswordRules: [
        (v) => v === this.member.password || "비밀번호가 맞지 않습니다..",
      ],
    };
  },
  computed: {
    passwordRules() {
      return this.$store.state.common.passwordRules;
    },
    nameRules() {
      return this.$store.state.common.nameRules;
    },
  },
  methods: {
    modifyMyPage() {
      if (this.$refs.form.validate()) {
        this.$axios({
          url: this.$config.baseUserMngURL + "/modifyMyPage",
          method: "post",
          data: {
            nickname: this.member.nickname,
            password: this.member.password,
          },
          headers: {
            "token-key": localStorage.getItem("token-key"),
            "token-setup": localStorage.getItem("token-setup"),
          },
        })
          .then((res) => {
            if (res.data.statusCode === 200) {
              this.$store.commit(
                "SET_SNACKBAR",
                setSnackBarInfo("사용자 정보 변경 성공")
              );
              this.$router.push("/");
            } else {
              this.$store.commit(
                "SET_SNACKBAR",
                setSnackBarInfo("사용자 정보 변경 실패")
              );
            }
          })
          .catch((err) => {
            this.$store.commit(
              "SET_SNACKBAR",
              setSnackBarInfo("서버 에러 발생")
            );

            this.errors.push(err);
            console.log(err);
          });
      }
    },
  },

  mounted() {
    this.$parent.$parent.$children.map(function (value, key) {
      if (value.$options._componentTag === "AppBar") {
        value.navTopBar = false;
      }
    });
    this.$axios({
      url: this.$config.baseUserMngURL + "/chkMyPage",
      method: "get",
      headers: {
        "token-key": localStorage.getItem("token-key"),
        "token-setup": localStorage.getItem("token-setup"),
      },
    })
      .then((res) => {
        this.results = res.data.data;
        this.member.nickname = res.data.data.nickname;
      })
      .catch((err) => {
        this.$store.commit("SET_SNACKBAR", setSnackBarInfo("서버 에러 발생"));

        this.errors.push(err);
        console.log(err);
      });
  },
};
</script>

<style scoped>
@media (min-width: 700px) {
  .register {
    width: 400px !important;
  }
}

.register {
  background-color: white;
  border-radius: 8px;
  width: 80%;
  border: white 1px solid;
  padding: 20px;
}
</style>
